const Mathf = {
  clamp(val, min, max) {
    if (val < min) {
      return min;
    }
    if (val > max) {
      return max;
    }
    return val;
  },
  isNumeric(value) {
    return typeof value !== 'object' && value - parseFloat(value) >= 0;
  },
};

export {Mathf};
